import { DEMO_LOGINS_WITHOUT_OMS, ELoginAs, LIVE_LOGINS_WITHOUT_CRM_AND_OMS } from '@aqx-core/common/api/auth';
import { authenticationViewController } from '@aqx-core/common/services/auth/controller';

import { validateCompanyAccess } from '../company-access';

export const normalizeSelectedLoginTab = ({
  selectedTab,
  companyAccess,
  multiServerEnabled
}: {
  selectedTab: ELoginAs | undefined;
  companyAccess: ReturnType<typeof validateCompanyAccess>;
  multiServerEnabled?: boolean;
}) => {
  const {
    hasMT4LiveLoginConfig,
    hasMT4DemoLoginConfig,
    hasMT5LiveLoginConfig,
    hasMT5DemoLoginConfig,
    hasCentroidLiveLoginConfig,
    hasCentroidDemoLoginConfig
  } = companyAccess;

  if (!selectedTab) {
    return selectedTab;
  }

  if (LIVE_LOGINS_WITHOUT_CRM_AND_OMS.includes(selectedTab)) {
    const liveLoginType = authenticationViewController.getLiveLoginTypeFromCompanyAccess({
      multiServerEnabled,
      hasMT5LiveLoginConfig,
      hasMT4LiveLoginConfig,
      hasCentroidLiveLoginConfig
    });
    return liveLoginType || selectedTab;
  }

  if (DEMO_LOGINS_WITHOUT_OMS.includes(selectedTab)) {
    const demoLoginType = authenticationViewController.getDemoLoginTypeFromCompanyAccess({
      multiServerEnabled,
      hasMT5DemoLoginConfig,
      hasMT4DemoLoginConfig,
      hasCentroidDemoLoginConfig
    });
    return demoLoginType || selectedTab;
  }

  return selectedTab;
};
